import { forwardRef, Ref, SyntheticEvent, useState } from "react"
import { Form, Formik, FormikProps } from "formik"
import { TabsOrder } from "./formConstants"
import { CreateMobileAVResourceForm } from "../../resourcesTypes"
import { TabPanel } from "../../../../../../../shared/components/tabs/tabPanel"
import * as yup from "yup"
import { useAppLocalization } from "../../../../../../localization/components/AppLocalizationProvider"
import { MobileAVFormTabs } from "./MobileAVFormTabs"
import { AccessControl } from "../room/accessControl/AccessControl"
import { FormMobileAVGeneralContent } from "./general/FormMobileAVGeneralContent"
import { AvailabilityContent } from "../room/availability/AvailabilityContent"

type CreateUpdateMobileAVFormProps = Readonly<{
    initialValues?: CreateMobileAVResourceForm | null
    onSubmit: (formData: CreateMobileAVResourceForm) => void
}>

const defaultInitialValues: CreateMobileAVResourceForm = {
    name: "",
    isActive: false,
    image: {
        uid: "",
    },
    avDetails: {
        type: "",
        serialNumber: "",
        storageLocation: "",
        floor: 0,
    },
    color: "",
    description: "",
    buffer: undefined,
    notifications: [],
    tags: [],
    closingTimes: [],
    accessControl: {
        limitAccess: false,
        visibleForAll: false,
        departmentIds: [],
    },
}

type FormikRef = Ref<FormikProps<CreateMobileAVResourceForm>>

export const CreateUpdateMobileAVForm = forwardRef(
    ({ initialValues, onSubmit }: CreateUpdateMobileAVFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()
        const [value, setValue] = useState(TabsOrder.GENERAL)

        const onTabChange = (_event: SyntheticEvent, newValue: number) => {
            setValue(newValue)
        }

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("required-field")),
        })

        function handleSubmit(values: CreateMobileAVResourceForm) {
            onSubmit(values)
        }

        return (
            <Formik<CreateMobileAVResourceForm>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <MobileAVFormTabs value={value} onChange={onTabChange} />
                    <TabPanel value={value} index={TabsOrder.GENERAL}>
                        <FormMobileAVGeneralContent />
                    </TabPanel>

                    <TabPanel value={value} index={TabsOrder.ACCESS_CONTROL}>
                        <AccessControl />
                    </TabPanel>

                    <TabPanel value={value} index={TabsOrder.AVAILABILITY}>
                        <AvailabilityContent />
                    </TabPanel>
                </Form>
            </Formik>
        )
    },
)
